import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";

import { Logo } from "./Logo";

export function LegalPage({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-paper">
      <header className="border-b border-line bg-paper">
        <div className="mx-auto flex max-w-[880px] items-center justify-between gap-4 px-5 py-[14px] md:px-8">
          <a href="/" aria-label="PortDwellr home">
            <Logo />
          </a>
          <Link to="/auth" className="text-[13px] font-semibold text-steel hover:underline">
            Sign In
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-[880px] px-5 py-12 md:px-8 md:py-16">
        <h1 className="text-[32px] font-bold leading-tight text-ink md:text-[40px]">{title}</h1>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.12em] text-steel-mid">
          {updated}
        </p>
        <div className="mt-10 space-y-9">{children}</div>
      </main>

      <footer className="border-t border-line">
        <div className="mx-auto flex max-w-[880px] flex-wrap items-center justify-between gap-3 px-5 py-6 font-mono text-[11px] uppercase tracking-[0.08em] text-steel-mid md:px-8">
          <span>© 2026 PORTDWELLR. AUTONOMOUS YARD INTELLIGENCE.</span>
          <span className="flex gap-4">
            <a href="mailto:upton@portdwellr.com">Contact</a>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </span>
        </div>
      </footer>
    </div>
  );
}

export function LegalSection({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="border-b border-line pb-2 text-[18px] font-semibold text-steel">{heading}</h2>
      <div className="mt-4 space-y-4 text-[15px] leading-relaxed text-ink-soft">{children}</div>
    </section>
  );
}
